import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, nextTick } from 'vue';
import { TransitionSpeed } from './constants';

interface Props {
  speed?: TransitionSpeed;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TransitionExpanded',
  props: {
    speed: null
  },
  setup(__props: any) {

const props = __props as {
  speed?: TransitionSpeed;
}



const computedSpeed = computed<TransitionSpeed>(() => {
  return props.speed || TransitionSpeed.MEDIUM;
})

function enter(element: HTMLElement) {
  nextTick(() => {
    element.style.width = getComputedStyle(element).width;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.height = 'auto';

    const height = getComputedStyle(element).height;

    element.style.width = '';
    element.style.position = '';
    element.style.visibility = '';
    element.style.height = '0';

    getComputedStyle(element).height;

    requestAnimationFrame(() => {
      element.style.height = height;
    });
  });
}
function afterEnter(element: HTMLElement) {
  element.style.height = 'auto';
}
function leave(element: HTMLElement) {
  element.style.height = getComputedStyle(element).height;

  getComputedStyle(element).height;

  requestAnimationFrame(() => {
    element.style.height = '0';
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: `expand-${_unref(computedSpeed)}`,
    onEnter: enter,
    onAfterEnter: afterEnter,
    onLeave: leave
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["name"]))
}
}

})